import { ApmVuePlugin } from '@elastic/apm-rum-vue';
import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';
import pack from '../package.json';
import { useMixpanelService } from './services/MixpanelService';

// let replay: Sentry.Replay;

let armadoApp: App<any> | undefined;

export function setArmadoApp (app: App<any>) {
	armadoApp = app;
}

export function getArmadoApp () {
	return armadoApp;
}

export function initSentry (app: any, router: Router) {
	/* replay = new Sentry.Replay({
		maskAllText: false,
		maskAllInputs: false,
	}); */

	Sentry.init({
		app,
		environment: import.meta.env.VITE_NODE_ENV,
		dsn: 'https://6823cc2d87074d598a09ea9cfe1ece9c@sentry.armado.fr/9',
		integrations: [Sentry.browserTracingIntegration({ router })],
		tracesSampleRate: 0.7,
		tracePropagationTargets: ['localhost:8080', 'myarmado.fr', 'dev.myarmado.fr', 'staging.myarmado.fr', 'demo.myarmado.fr', /^\//],
		release: pack.version,
		enabled: import.meta.env.VITE_NODE_ENV !== 'development',
	});
}

export function initElasticApm (app: any, router: Router) {
	if (import.meta.env.VITE_NODE_ENV !== 'development') {
		const apmActive = Math.random() < 0.1;
		app.use(ApmVuePlugin, {
			router,
			captureErrors: true,
			config: {
				serviceName: 'armado-frontend',
				serverUrl: '/app/apmproxy',
				environment: import.meta.env.VITE_NODE_ENV,
				active: apmActive,
				transactionSampleRate: 0.2,
				flushInterval: 2000,
			},
		});
	}
}

export function initMixpanel () {
	useMixpanelService().init();
}

export { Sentry };
